export class VooRequisicao {
    public dtFim: any;
    public dtInicio: any;
    public sistOrigin: string;
}
